import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const selectManageAccessState = (state: RootState) => state.manageAccess;

export const selectManageAccessStep = createSelector(
  selectManageAccessState,
  (state) => state.step
);
export const selectManageAccessSubmitting = createSelector(
  selectManageAccessState,
  (state) => state.isSubmitting
);
export const selectManageAccessSixId = createSelector(
  selectManageAccessState,
  (state) => state.sixId
);

export const selectManageAccessDraft = createSelector(
  selectManageAccessState,
  (state) => state.draft
);
export const selectManageAccessInternalUsers = createSelector(
  selectManageAccessState,
  (state) => state.internalUsers
);
export const selectManageAccessExternalUsers = createSelector(
  selectManageAccessState,
  (state) => state.externalUsers
);
export const selectManageAccessExternalSeatsAvailable = createSelector(
  selectManageAccessState,
  (state) => state.externalSeats?.available ?? 0
);
